import { Inject } from '@angular/core'
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog'

export abstract class AbstractDialogComponent<Data, Component> {
    constructor(
        @Inject(MAT_DIALOG_DATA) public data: Data,
        public dialogRef: MatDialogRef<Component>
    ) {
        // this.dialogRef.addPanelClass('wp');
    }
}
